import React from "react";
import PropTypes from "prop-types";

const TableBorderNoSideIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 14 12"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="#CCC" stroke="none" fillRule="evenodd">
      <path d="M3 0h2v2H3zM6 0h2v2H6zM9 0h2v2H9zM12 0h2v2h-2zM0 0h2v2H0z" />
      <g>
        <path d="M3 10h2v2H3zM6 10h2v2H6zM9 10h2v2H9zM12 10h2v2h-2zM0 10h2v2H0z" />
      </g>
    </g>
  </svg>
);
TableBorderNoSideIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default TableBorderNoSideIcon;
